module.exports = __webpack_public_path__ + "img/menu-customerService.ab6a6381.svg";